import React from 'react';
import { Star } from 'lucide-react';

/**
 * Ürün kartları ve listeler için kompakt yıldız + ortalama puan.
 */
const ProductRatingStars = ({ ratingAverage, ratingCount, size = 'sm', className = '' }) => {
  const avg = parseFloat(ratingAverage) || 0;
  const count = parseInt(ratingCount, 10) || 0;
  const filled = Math.round(avg);
  const iconClass = size === 'xs' ? 'h-3 w-3' : 'h-3.5 w-3.5 sm:h-4 sm:w-4';
  const textClass = size === 'xs' ? 'text-[10px]' : 'text-xs sm:text-sm';

  return (
    <div className={`flex items-center gap-1 min-w-0 ${className}`}>
      <div className="flex items-center shrink-0" aria-label={`Ortalama ${avg.toFixed(1)} / 5`}>
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            className={`${iconClass} ${
              star <= filled ? 'text-orange-400 fill-orange-400' : 'text-gray-200'
            }`}
          />
        ))}
      </div>
      {count > 0 ? (
        <span className={`${textClass} text-gray-500 truncate`}>
          {avg.toFixed(1)} ({count})
        </span>
      ) : (
        <span className={`${textClass} text-gray-400 truncate`}>Henüz yorum yok</span>
      )}
    </div>
  );
};

export default ProductRatingStars;
